module.exports = __webpack_public_path__ + "img/arrow-up.dbbeeb35.svg";